var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, useTheme, Box } from '@material-ui/core';
export var ConfirmButton = function (_a) {
    var buttonClassName = _a.buttonClassName, icon = _a.icon, id = _a.id, title = _a.title, description = _a.description, onConfirm = _a.onConfirm, children = _a.children, buttonProps = __rest(_a, ["buttonClassName", "icon", "id", "title", "description", "onConfirm", "children"]);
    var spacing = useTheme().spacing;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, __assign({}, buttonProps, { className: buttonClassName, onClick: function () { return setOpen(true); } }),
            icon && (React.createElement(Box, { mr: spacing(0.15) },
                React.createElement(FontAwesomeIcon, { icon: icon }))),
            children),
        React.createElement(Dialog, { open: open, onClose: function () { return setOpen(false); }, "aria-labelledby": "alert-" + id + "-title", "aria-describedby": "alert-" + id + "-description" },
            React.createElement(DialogTitle, { id: "alert-" + id + "-title" }, title),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: "alert-" + id + "-description" }, description)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setOpen(false); } }, "Cancel"),
                React.createElement(Button, { onClick: function (e) {
                        onConfirm(e);
                        setOpen(false);
                    }, variant: 'contained', autoFocus: true }, "Delete")))));
};
//# sourceMappingURL=confirm-button.js.map